/* eslint-disable global-require */

type WeathersIconKeyType = {
  [key: string]: string;
};

const weathersIcon: WeathersIconKeyType = {
  '01d': require('./icon_troi_nang.svg').default,
  '02d': require('./icon_co_may.svg').default,
  '03d': require('./icon_nhieu_may.svg').default,
  '04d': require('./icon_nhieu_may.svg').default,
  '09d': require('./icon_mua_to.svg').default,
  '10d': require('./icon_mua.svg').default,
  '11d': require('./icon_mua_co_sam.svg').default,
  '13d': require('./icon_tuyet.svg').default,
  '50d': require('./icon_co_may.svg').default,

  '01n': require('./icon_troi_nang.svg').default,
  '02n': require('./icon_co_may.svg').default,
  '03n': require('./icon_nhieu_may.svg').default,
  '04n': require('./icon_nhieu_may.svg').default,
  '09n': require('./icon_mua_to.svg').default,
  '10n': require('./icon_mua.svg').default,
  '11n': require('./icon_mua_co_sam.svg').default,
  '13n': require('./icon_tuyet.svg').default,
  '50n': require('./icon_co_may.svg').default,
};

/* eslint-enable global-require */

export default weathersIcon;
